import create from 'zustand'

type ModuleStateOptions = 'edit' | 'display'

interface ReportDetailChatSidebar {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  // TODO the values below are not about the sidebar (even though they are related) -> create new store or rename this one
  activeModuleId: number | null
  setActiveModuleId: (value: number | null) => void
  activeModuleState: ModuleStateOptions
  setActiveModuleState: (value: ModuleStateOptions) => void
  closeChat: () => void
}

export const useReportDetailChatSidebarStore = create<ReportDetailChatSidebar>(set => ({
  isOpen: false,
  setIsOpen: value => set(() => ({ isOpen: value })),
  // TODO the values below are not about the sidebar (even though they are related) -> create new store or rename this one
  activeModuleId: null,
  setActiveModuleId: value => set(() => ({ activeModuleId: value })),
  activeModuleState: 'display',
  setActiveModuleState: value => set(() => ({ activeModuleState: value })),
  closeChat: () => set(() => ({ isOpen: false, activeModuleId: null, activeModuleState: 'display' })),
}))
